module.exports = __webpack_public_path__ + "img/img2.efa9453f.png";